import { useEffect, useState } from "react";

export const useSeeMore = (text, slice = 160) => {
  
  const [fullText, setFullText] = useState('');
  const [extractedText, setExtractedText] = useState('');
  const [isFullText, setIsFullText] = useState(false);
  const [isMore, setIsMore] = useState(false);

  useEffect(() => {
    setFullText(text);
    const slicedText = text.slice(0, slice);
    const dottedSplicedText = slicedText.length < text.length ? `${slicedText} ... ` : slicedText;
    setExtractedText(dottedSplicedText);

    slicedText.length < text.length && setIsMore(true);
  }, [text, slice]);

  // click see more text
  const seeMore = () => setIsFullText(prev => !prev);

  return {
    fullText,
    extractedText,
    isFullText,
    seeMore,
    isMore,
  }
}